"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Gauge;
var _react = _interopRequireDefault(require("react"));
var _radialBar = require("cccisd-nivo/radial-bar");
var _cccisdColorPicker = require("cccisd-color-picker");
var _Settings = _interopRequireWildcard(require("./Settings"));
var _GaugeNeedle = _interopRequireDefault(require("./GaugeNeedle"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Gauge(_ref) {
  var data = _ref.data,
    _ref$ranges = _ref.ranges,
    ranges = _ref$ranges === void 0 ? [] : _ref$ranges,
    settings = _ref.settings;
  if (typeof settings.colors === 'string') {
    if (settings.colors === 'custom') {
      settings.colors = (0, _cccisdColorPicker.getColor)(settings.customColors);
    } else {
      settings.colors = {
        scheme: settings.colors
      };
    }
  }
  data[0].data = ranges === null || ranges === void 0 ? void 0 : ranges.filter(Boolean).sort(function (a, b) {
    return a[0] - b[0];
  }).map(function (r, i, arr) {
    var y = r[0];
    if (arr[i - 1]) {
      y -= arr[i - 1][0];
    }
    return {
      x: "Range".concat(i + 1),
      y: y,
      color: r[1]
    };
  });
  var GaugeNeedleLayer = (0, _GaugeNeedle["default"])({
    value: data[0].value
  });
  return /*#__PURE__*/_react["default"].createElement(_radialBar.ResponsiveRadialBar, _extends({
    data: data
  }, settings, settings.showLegend ? {} : {
    legends: []
  }, {
    margin: {
      top: 40,
      left: 40,
      right: 40,
      bottom: -200
    },
    layers: ['grid', 'tracks', 'bars', 'labels', 'legends', GaugeNeedleLayer],
    colors: data[0].data.map(function (d) {
      return d.color;
    })
  }));
}
Gauge.Settings = function (_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    field: field,
    form: form
  }, children);
};
Gauge.initialValues = _Settings.initialValues;